import React, { Component } from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import trLocale from '@fullcalendar/core/locales/tr';
import interactionPlugin from "@fullcalendar/interaction";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import CommissionNote from "./CommissionNote";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {formatDateTime, showAxiosError} from "../../util/Helpers";
class CommissionCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            currentEvent: {
                id: null,
                title: "",
                topic: "",
                start: "",
                time: "",
                date: "",
                note: ""
            },
            isFormVisible: false,
            isConfirmationModalVisible: false,
            listMeeting:[],
            selectedDate:null,
        };
        this.calendarRef = React.createRef();
        this.listMeetings=this.listMeetings.bind(this);
    }
    handleDateClick = (arg) => {
        const { date } = arg;

        if (this.state.currentEvent.id === null) {
            const correctDate = new Date(date.setHours(date.getHours()+3))
            this.setState({
                selectedDate: correctDate.toISOString(),
                isFormVisible: false,
                isConfirmationModalVisible: false,
            });
        } else {
            this.setState({
                selectedDate: null,
                currentEvent: {
                    id: null,
                    title: "",
                    time: "",
                    date: "",
                    note: ""
                },
                isFormVisible: false,
                isConfirmationModalVisible: false,
            });
        }
    }
    handleEventClick = (info) => {
        const date= info.event.start;
        const correctDate = new Date(date.setHours(date.getHours()+3))
        this.setState({
            currentEvent: {
                id: info.event.toPlainObject().id,
                title: info.event.toPlainObject().title,
                time: info.event.toPlainObject().extendedProps.time,
                date: info.event.start.toISOString(),
                note: info.event.toPlainObject().extendedProps.note
            },
            selectedDate: correctDate,
            isFormVisible: true,
            isConfirmationModalVisible: false,
        });
    };
    listMeetings() {
        let self = this;
        let params = {
            url: API_BASE_URL+'/allMeets' ,
            method: "get",
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                let listMeeting = response.data;
                self.setState({
                    listMeeting,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });

    }
    formatEvents = (data) => {
        return data.map(event => {
            const tarihParts = event.toplantiTarihi.split('-');
            const yil = parseInt(tarihParts[0]);
            const ay = parseInt(tarihParts[1]) - 1;
            const gun = parseInt(tarihParts[2]);
            const tarih = new Date(yil, ay, gun);

            return {
                id: event.id,
                title: event.toplantiKonusu,
                start: tarih,
                time: event.toplantiSaati,
                note: event.note
            };
        });
    };
    componentDidMount() {
        this.listMeetings();
    }

    render() {
        const { events, currentEvent, isFormVisible } = this.state;

        const events2 = this.formatEvents(this.state.listMeeting);
        return (
            <div className="App">
                <FullCalendar
                    defaultView="dayGridMonth"
                    ref={this.calendarRef}
                    header={{
                        left: "prevYear,prev,today,next,nextYear",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    themeSystem="simple-silver"
                    plugins={[dayGridPlugin, interactionPlugin]}
                    locale={trLocale}
                    events={events2}
                    dateClick={this.handleDateClick}
                    eventClick={this.handleEventClick}
                    eventContent={(arg) => {
                        const saatObjesi = new Date("1970-01-01T" + arg.event.extendedProps.time + "Z");
                        saatObjesi .setUTCHours(saatObjesi .getUTCHours()+1)
                        const yeniSaat=saatObjesi.toISOString().substr(11,8);
                        return (
                        <div style={{ backgroundColor: '#dadada', border: '1px solid #dadada' ,textAlign:"center"}}>
                            {/*<button onClick={() => this.setState({ isFormVisible: false, isConfirmationModalVisible: true })} style={{ background: 'red', left: '100px', top: '-11px', padding: '5px', opacity: '0.6' }} className="Btn btn-sm btn-icon"><strong>X</strong></button>*/}
                            <h2 style={{ color: 'black', marginTop:"30px"}}>{arg.event.start.toLocaleDateString()}</h2>
                            <h2 style={{ color: 'black', marginTop:"30px"}}>{arg.event.title}</h2>
                            <h4 style={{ color: '#e54343', marginTop:"30px"}}>{yeniSaat}</h4>
                        </div>
                        );
                    }}
                    buttonText={{
                        today: 'Bugün',
                    }}
                />
                <Modal isOpen={isFormVisible} size="md" className="ust">
                    <ModalHeader toggle={() => this.setState({ isFormVisible: false })}>Toplantı Bilgileri </ModalHeader>
                    <ModalBody>
                        <CommissionNote
                            onSave={this.saveEvent}
                            onCancel={() => this.setState({ isFormVisible: false })}
                            currentEvent={currentEvent}
                            selectedDate={this.state.selectedDate}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
export default CommissionCalendar;



// WEBPACK FOOTER //
// ./src/page/agenda/commissionCalendar.js